import { string } from '@gogame/schemas';
import { rangePresets } from '@gogame/intl-ts';
import { getPayToByPeriod } from './utils';
export const payToSchema = string()
  .when('$stripPayTo', (stripPayTo, schema) =>
    stripPayTo ? schema.strip() : schema
  )
  .default(getPayToByPeriod(rangePresets.LAST_7_DAYS.value))
  .required('Pay to');
